import { render } from "./checkRebate.vue?vue&type=template&id=5c6be39c"
import script from "./checkRebate.vue?vue&type=script&lang=js"
export * from "./checkRebate.vue?vue&type=script&lang=js"

import "./checkRebate.vue?vue&type=style&index=0&id=5c6be39c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__